/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
import axios from 'axios'
import { initializeSessionRecovery } from './session-recovery'

window.axios = axios
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
initializeSessionRecovery({ axios: window.axios, window, document })

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

window.Pusher = Pusher

const options = {
    broadcaster: 'pusher',
    key: import.meta.env.VITE_PUSHER_KEY,
    cluster: import.meta.env.VITE_PUSHER_CLUSTER,
    encrypted: true,
    forceTLS: !['local', 'testing'].includes(import.meta.env.VITE_APP_ENV),
    // APP_URL may name the main app while this page is served from the nurse
    // subdomain. Private-channel authorization must stay on this page's origin.
    authEndpoint: '/broadcasting/auth',
}

let keyExists = options.key !== undefined && options.key !== null

if (!keyExists) {
    console.log('pusher app key not found')
}

if (keyExists) {
    window.Echo = window.EchoPusher = new Echo(options)
    console.log('echo:success')
} else {
    console.log('bootstrapjs echo:failed')
}
